"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteNotifyFlags = exports.FavoriteNotifyMode = exports.FavoriteFlags = exports.FavoriteSortFlags = exports.FavoriteItemType = void 0;
/** Тип элемента в списке избранного (команда mf). */
exports.FavoriteItemType = {
    FORUM: 0,
    TOPIC: 1,
};
/** Флаги сортировки запроса mf (параметр Flags). */
exports.FavoriteSortFlags = {
    UNREAD_FIRST: 1,
    BY_NAME: 4,
    REVERSE: 8,
};
/** Флаги элемента избранного (индекс 4 в ответе mf). */
exports.FavoriteFlags = {
    IMPORTANT: 1,
    UNREAD: 32,
};
/** Режим уведомлений (индекс 11 в ответе mf, младшие 2 бита). */
exports.FavoriteNotifyMode = {
    OFF: 0,
    ALWAYS: 1,
    ONCE: 2,
};
/** Доп. флаг уведомлений: оповещать о шапке темы (бит 4). */
exports.FavoriteNotifyFlags = {
    HEADER: 4,
};
